<script>
import { mapGetters } from 'vuex';

export default {
    name:     'HeaderNavigation',
    computed: {
        ...mapGetters({
            isGranted:         'aclAccess/isGranted',
            userGroup:         'user/getGroup',
            getPartnerRequest: 'user/getPartnerRequest',
        }),
    },
};
</script>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from '@/store/index.js';
import NavigationLogin from '@/components/app/header/navigation/login';
import NavigationLogout from '@/components/app/header/navigation/logout';
import NavigationBalance from '@/components/app/header/navigation/balance';
import NavigationManager from '@/components/app/header/navigation/manager';
import NavigationPartner from '@/components/app/header/navigation/partner';
import NavigationSettings from '@/components/app/header/navigation/settings';
import { forEachAppModule } from '@/modules/registry';
import { OTHER, USER } from '@/store/modules/acl-access/constants.ts';
import { emitter } from '@/utils/event/emitter.ts';
import { APP } from '@/utils/event/constants.ts';

const modulesActions = ref([]);

function initModulesSections() {
    const sections = [];

    forEachAppModule((module) => {
        (module.headerNavigation ?? []).forEach((action) => {
            sections.push(action);
        });
    });

    modulesActions.value = sections;
}

initModulesSections();

const store = useStore();

const isGranted = computed(() => store.getters['aclAccess/isGranted']);
const userGroup = computed(() => store.getters['user/getGroup']);

const items = computed(() => [
    {
        component: NavigationSettings,
        divider:   true,
    },
    ...modulesActions.value,
    {
        component: NavigationManager,
        condition: userGroup.value === 'employee',
    },
    {
        component: NavigationLogin,
        condition: isGranted.value(USER.LOGIN),
    },
    {
        component: NavigationBalance,
        condition: isGranted.value(OTHER.PAYMENT_ADD),
    },
    {
        component: NavigationPartner,
        condition: isGranted.value(USER.PARTNER_REQUEST),
    },
    {
        component: NavigationLogout,
        condition: isGranted.value(USER.LOGOUT),
    },
].filter(item => item.condition ?? true));

emitter.on(APP.MODULES, initModulesSections);
</script>

<template>
    <div
        class="flex flex-col p-3 gap-y-1"
        :data-test="dataTest()"
    >
        <template v-for="(item, index) in items">
            <component
                :key="`section-${index}`"
                :is="item.component"
                @navigate="$emit('navigate')"
            />
            <div
                v-if="item.divider"
                :key="`divider-${index}`"
                class="border-t w-full"
            />
        </template>
    </div>
</template>
